import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '@app/shared/material/material.module';
import { TranslateModule } from '@ngx-translate/core';

export interface ConfirmationDialogData {
    text: string;
    checkBoxText?: string;
}

export interface ConfirmationDialogResult {
    isConfirmed: boolean;
    isCheckboxTicked: boolean;
}

@Component({
    selector: 'app-ecmr-confirmation-dialog',
    templateUrl: './ecmr-confirmation-dialog.component.html',
    styleUrl: './ecmr-confirmation-dialog.component.scss',
    imports: [CommonModule, MaterialModule, TranslateModule],
})
export class EcmrConfirmationDialogComponent {
    dialogResult: ConfirmationDialogResult = {
        isConfirmed: false,
        isCheckboxTicked: false,
    };

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: ConfirmationDialogData,
        public dialogRef: MatDialogRef<EcmrConfirmationDialogComponent>
    ) {}

    toggleCreateCopy() {
        this.dialogResult.isCheckboxTicked =
            !this.dialogResult.isCheckboxTicked;
    }

    close(isConfirmed: boolean) {
        this.dialogResult.isConfirmed = isConfirmed;
        this.dialogRef.close(this.dialogResult);
    }
}
